import React, { useEffect } from "react";
import styles from "./SegmentationOverlay.module.scss";

interface SegmentationOverlayProps {
	overlayCanvasRef: React.RefObject<HTMLCanvasElement>;
	isVisible: boolean;
	mainCanvasRef: React.RefObject<HTMLCanvasElement>;
	canvasStyle?: React.CSSProperties;
}

const SegmentationOverlay: React.FC<SegmentationOverlayProps> = ({
	overlayCanvasRef,
	isVisible,
	mainCanvasRef,
	canvasStyle,
}) => {
	useEffect(() => {
		const mainCanvas = mainCanvasRef.current;
		const overlayCanvas = overlayCanvasRef.current;

		if (!mainCanvas || !overlayCanvas) return;

		const syncCanvasPosition = () => {
			const mainRect = mainCanvas.getBoundingClientRect();
			const parentRect = mainCanvas.offsetParent?.getBoundingClientRect() || { left: 0, top: 0 };

			overlayCanvas.style.position = "absolute";
			overlayCanvas.style.left = `${mainRect.left - parentRect.left}px`;
			overlayCanvas.style.top = `${mainRect.top - parentRect.top}px`;
			overlayCanvas.style.width = `${mainRect.width}px`;
			overlayCanvas.style.height = `${mainRect.height}px`;

			overlayCanvas.width = mainCanvas.width;
			overlayCanvas.height = mainCanvas.height;
		};

		syncCanvasPosition();

		const resizeObserver = new ResizeObserver(syncCanvasPosition);
		resizeObserver.observe(mainCanvas);

		window.addEventListener("resize", syncCanvasPosition);

		return () => {
			resizeObserver.disconnect();
			window.removeEventListener("resize", syncCanvasPosition);
		};
	}, [mainCanvasRef, overlayCanvasRef]);

	return (
		<canvas
			ref={overlayCanvasRef}
			className={styles.overlayCanvas}
			style={{
				...canvasStyle,
				opacity: isVisible ? 1 : 0,
				pointerEvents: "none",
				position: "absolute",
				zIndex: 10,
				transition: "opacity 0.1s ease-in-out",
			}}
		/>
	);
};

export default SegmentationOverlay;
